import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import { ConsultEventInd, UpdEvent } from '../../../funciones/AgendaFunction';

class EditEvent extends Component {
    state = {
        valorColor: { value: '', label: '888888' },
        quien: { value: '', label: '- ¿Quién puede ver esto? -' },
        dEvent: "",
        fechaIn: "",
        fechaOut: "",
        boton1: {
            text:"Cargando Datos",
            icon: "fa fa-spinner fa-spin",
            disabled: true
        },
        cantErrores: ""
    }

    constructor (props) {
        super (props);
        ConsultEventInd ( this.props.id, (resp) => {
            this.setState({
                fechaIn: resp.fecha_in,
                fechaOut: resp.fecha_out,
                dEvent: resp.event_name,
                valorColor: { value: resp.id, label: resp.codigo_color },
                boton1: {
                    text:"Actualizar",
                    icon: "fa fa-save",
                    disabled: false
                },
                quien: this.props.quienes[(resp.status - 1)]
            })
        })
        
    }

    isValidDate = (dateString) => (e) => {
        if (dateString === "") return null;

        let fechaTmp = dateString.replace("/", "-")
        let fechaTmp2 = fechaTmp.replace("/", "-")
        let fecha = new Date(fechaTmp2)

        if (isNaN(fecha.getTime())) {
            this.setState({
                fechaIn: ""
            }, () => {
                toast.error("La fecha introducida es inválida",{autoClose: 4000})
            })
        }else{
            let regEx = /^\d{2}-\d{2}-\d{4}$/;
            if(fechaTmp2.match(regEx) === null) {
                this.setState({
                    fechaIn: ""
                }, () => {
                    toast.error("Las fechas deben tener el formato dd/mm/aaaa",{autoClose: 4000})
                })
            }
        }
    }

    cambiaValor = (prop) => (event) => {
        let data = event.target.value
        switch (data.length) {
            case 2:
                data = data + "/";
                break;
            case 5:
                data = data + "/";
                break;
            default:
                break;
        }
    
        let fechaTmp = data.replace("-", "/")
        let fechaTmp2 = fechaTmp.replace("-", "/")
        this.setState({
            [prop]: fechaTmp2,
        });
    };

    cambiaValor2 = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value,
        });
    };

    valorQuien = (quien) => {
        this.setState({
            quien,
        })
    }

    respuestaEditar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let respOk = (mensaje) => {

            this.props.funcion();

            this.setState({
                boton1:{
                    text:"Cargando Datos",
                    icon: "fa fa-spinner fa-spin",
                    disabled: true
                },
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.setState({ cantErrores:"" })
        }
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        respOk(mensaje[0]);
    }

    render() {
        let { valorColor, quien, dEvent, fechaIn, fechaOut, boton1, cantErrores } = this.state;
        let { colores, quienes } = this.props;

        let cambiaColor = (color) => (e) => {
            this.setState({
                valorColor: color,
                openConfirm: false,
                openDel: false,
                openEdit: false
            })
        }

        let coloresD = () => (
            colores.map(option => (
                <span style={{paddingLeft: 5, paddingTop: 5, paddingBottom: 5,}} key={Math.round(Math.random()*100000)}>
                    <i className="fa fa-square" onClick={cambiaColor(option)} title={option.label} style={{color: option.label, cursor:"pointer"}}></i>
                </span>
            ))
        )

        let MainColor = (
            <Popover title="Colores Disponibles" id="colores">
                <div align="center" style={{height: 100, width:150}}>
                    {coloresD()}
                </div>
            </Popover>
        )

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        return (
            <Row>
                <Col md={3}>
                    <input type="text" value={fechaIn} onBlur={this.isValidDate(fechaIn)} onChange={this.cambiaValor("fechaIn")} className="form-control" placeholder="DD/MM/AAAA"/>
                    <span className="text-muted" style={{fontSize: 10}}>Desde</span>
                </Col>
                <Col md={3}>
                    <input type="text" value={fechaOut} onBlur={this.isValidDate(fechaOut)} onChange={this.cambiaValor("fechaOut")} className="form-control" placeholder="DD/MM/AAAA"/>
                    <span className="text-muted" style={{fontSize: 10}}>Hasta</span>
                </Col>
                <Col md={6}>
                    <Select
                        styles={{menu: customStyles}}
                        isSearchable ={true}
                        value={quien}
                        onChange={this.valorQuien}
                        options={quienes}
                    />
                    <span className="text-muted" style={{fontSize: 10}}>Compartir</span>
                </Col>
                <Col md={7} className="custom-mt-10">
                    <textarea className="form-control" placeholder="Descriṕción del evento" onChange={this.cambiaValor2("dEvent")} value={dEvent}></textarea>
                </Col>
                <Col md={5} className="custom-mt-10" align="right">
                    <OverlayTrigger trigger="focus" placement="bottom" overlay={ MainColor }>
                        <button className="btn btn-default" style={{borderWidth:1, borderColor:"CCC", backgroundColor: "FFF", color: valorColor.label}} title="Selecciona un Color"><i className="fa fa-square"></i> Selecciona un color <i className="fa fa-caret-up"></i></button>
                    </OverlayTrigger>
                </Col>
                <Col md={7}>
                    <div className="text-danger">{ cantErrores }</div>
                </Col>
                <Col md={5} className="custom-mt-10" align="right">
                    <button className="btn btn-primary" disabled={boton1.disabled} style={{borderWidth:1}} title="Guardar Cambios"
                        onClick = {
                            () => {
                                this.setState({
                                    boton1: {
                                        text:"Espera",
                                        icon: "fa fa-spinner fa-spin"
                                    }
                                }, () => {
                                    let campos = {
                                        valorColor, quien, dEvent,
                                        fechaIn, fechaOut
                                    }

                                    UpdEvent(this.props.id, campos, (resp) => {
                                        this.respuestaEditar(resp)
                                    })
                                })
                            }
                        }
                    ><i className={boton1.icon}></i> {boton1.text}    
                    </button>
                </Col>
            </Row>
        );
    }
}
 
export default EditEvent;


// WEBPACK FOOTER //
// ./src/views/Academicos/CalendarioContent/EditEvent.jsx